import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { ContainerProps } from '@/components/Container';
import { Container } from '@/components/Container';

export const ExpanderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  ${({
    theme: {
      colors,
      components: {
        breadcrumb: { expander },
      },
    },
  }) => css`
    background: ${colors.mediumGrey};
    width: ${expander.width};
    height: ${expander.height};
    margin-right: ${expander.marginRight};
    border-radius: ${expander.borderRadius};
    gap: ${expander.gap};
  `}
`;

export const Dot = styled.span`
  border-radius: 50%;

  ${({
    theme: {
      colors,
      components: {
        breadcrumb: { dot },
      },
    },
  }) => css`
    background-color: ${colors.primaryBlue};
    width: ${dot.width};
    height: ${dot.height};
  `}
`;

export const Wrapper = styled(Box)`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  width: 100%;
`;

interface ItemWrapper {
  inverted: boolean;
}

export const ItemWrapper = styled(Box)<ItemWrapper>`
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes.p3};

  a {
    text-decoration: none;
    color: ${({ inverted, theme }) =>
      inverted ? theme.colors.white : theme.colors.primaryDark};
    opacity: 50%;
    transition: all 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
      opacity: 1;
    }

    &:visited {
      color: 'inherit';
    }
  }

  span {
    color: ${({ inverted, theme }) =>
      inverted ? theme.colors.white : theme.colors.primaryBlue};
  }

  svg {
    margin: 0 6px;
  }
`;

export const BreadcrumbWrapper = styled(Container)<ContainerProps>`
  ${({
    theme: {
      components: { header },
      space,
    },
  }) => css`
    padding-inline: ${space.s100};
    @media (min-width: ${header.breakpoint}) {
      padding-inline: ${space.s250};
    }
  `}
`;
